import { SIGN_UP_SUCCESS, SIGN_UP_FAILURE, RESET_SIGN_UP } from '../constants/action_types';
import { postUser } from '../api/api';
import moment from "moment";

const signUpSuccess = (data) => ({
    type: SIGN_UP_SUCCESS,
    data
});

const signUpFailure = () => ({
    type: SIGN_UP_FAILURE
});

const resetSignUp = () => ({
    type: RESET_SIGN_UP
});

const submitSignUp = (data) => dispatch => {
    if(data.optInForNewsletter === undefined){
        data.optInForNewsletter=false;
    }
    const finalData = {
        ...data,
        phoneNumber: data.phoneNumber,
        country: data.country ? {
            label: data.country.label,
            value: data.country.value,
        } : null,
        locale: moment().locale()
    };

    return postUser(finalData)
        .then(res => {
            if (!res.ok) {
                return dispatch(signUpFailure());
            }

            return dispatch(signUpSuccess(res.body.data));
        })
        .catch(error => {
            return dispatch(signUpFailure());
        });
};

export {
    submitSignUp,
    resetSignUp
};
